import Vue from "vue";
import VueSweetalert2 from 'vue-sweetalert2';
import VueTelInput from 'vue-tel-input';
import VCalendar from 'v-calendar';
import ParagraphSkeleton from '@/components/skeletons/Paragraph';
import HeaderSkeleton from '@/components/skeletons/Header';
// import ImageSkeleton from '@/components/skeletons/Image';
import CustomBtn from "@/components/globals/CustomBtn.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import {InlineSvgPlugin} from 'vue-inline-svg';

Vue.use(VueTelInput);
Vue.use(VueSweetalert2);
Vue.use(VCalendar, {
  componentPrefix: 'v',
});
Vue.use(InlineSvgPlugin);

Vue.component('ParagraphSkeleton', ParagraphSkeleton);
Vue.component('HeaderSkeleton', HeaderSkeleton);
// Vue.component('ImageSkeleton', ImageSkeleton);
Vue.component('checkbox', CheckboxInput);

Vue.component('btn', CustomBtn)
